import React, { Component } from 'react';
import autobind from 'class-autobind';

import {
  setTextLinksToDisplayExternalOpenMsg
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const CustomFooterUi = ({ tellRef, footerHtml })=> (
  <div
    ref={tellRef}
    className="custom-footer"
    dangerouslySetInnerHTML={{
      __html: footerHtml
    }}
  />
);

const CustomFooter_ViewerVersion1 = (props)=>
  <CustomFooterUi { ...props } />;

class CustomFooter_ViewerVersion2 extends Component {

  constructor() {
    super();

    this.customFooterRef = null;

    autobind(this);
  }

  handleCustomFooterRefReceived(ref) {
    this.customFooterRef = ref;

    setTextLinksToDisplayExternalOpenMsg(this.customFooterRef, 'a');
  }

  render() {
    return <CustomFooterUi { ...this.props } tellRef={this.handleCustomFooterRefReceived} />;
  }

}

const CustomFooter = (props)=> (
  <SiteViewerVersionComponentSelector>
    <CustomFooter_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <CustomFooter_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default CustomFooter;
